import { Modal, Form, Button, Col, Dropdown, Input, Layout, List, Menu, message, Row, Space, Select, Spin, Tooltip, FormInstance, ModalProps } from 'antd'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { ProFormInstance, ProFormText, ProFormTextArea, ProFormDigit, ProFormRadio, ModalForm } from '@ant-design/pro-form'

export type OrderRefundRequest = {
  id: string;
  refundAmount: number;
  refundTo: string;
  comment: string;
};

export type OrderRefundFormProps = {
  visible: boolean;
  onCancel: any;
  onSubmit: (values: OrderRefundRequest) => Promise<void>;
  /** @name 弹框的标题 */
  title?: ModalProps['title'];
  width?: any;
  formValues?: any;
};

const OrderRefundForm: React.FC<OrderRefundFormProps> = (props) => {
  const formRef = useRef<ProFormInstance<any> | undefined>();
  const [newValue, setNewValue] = useState<any>({})
  const [stockMethod, setStockMethod] = useState<string>('return')
  const [refundMethod, setRefundMethod] = useState<string>('credit')
  return (
    <ModalForm title={props.title}
      grid={true}
      visible={props.visible}
      autoFocusFirstInput
      initialValues={props.formValues}
      modalProps={{
        destroyOnClose: true,
        onCancel: () => { props.onCancel(); },
      }}
      onFinish={async (values) => {
        props.onSubmit({
          ...values,
          refundMethod: refundMethod,
          refundTo: refundMethod,
          stockMethod: stockMethod
        })
      }}
      layout="horizontal"
      autoComplete="off"
      onValuesChange={(value, all) => { console.log(newValue); setNewValue({ ...newValue, ...all }); }}
      formRef={formRef} >
      <ProFormRadio.Group colProps={{ md: 12 }}
        style={{
          margin: 16,
        }}
        label="退款方式"
        radioType="button"
        fieldProps={{
          value: stockMethod,
          onChange: (e) => setStockMethod(e.target.value),
        }}
        options={[{ value: 'return', label: '返还入库' }, { value: 'refund_only', label: '仅退款' }]}
      />
      <ProFormRadio.Group colProps={{ md: 12 }}
        style={{
          margin: 16,
        }}
        label="退款去向"
        radioType="button"
        fieldProps={{
          value: refundMethod,
          onChange: (e) => setRefundMethod(e.target.value),
        }}
        options={[{ value: 'credit', label: '充预存' }, { value: 'return', label: '原路退回' }, { value: 'cash', label: '现金' }]}
      />
      <ProFormDigit name="refundAmount" label="退款金额" colProps={{ md: 24 }} min={0} fieldProps={{ prefix: "$", controls: false }}></ProFormDigit>
      {/* <ProFormDigit name="refundPoints" label="退还积分" colProps={{ md: 12 }} min={0} fieldProps={{ precision: 0, controls: false }}></ProFormDigit>
      <ProFormDigit name="returnPoints" label="收回积分" colProps={{ md: 12 }} min={0} fieldProps={{ precision: 0, controls: false }}></ProFormDigit> */}
      <ProFormTextArea name="comment" label="详情备注" colProps={{ md: 24 }} ></ProFormTextArea>
    </ModalForm>
  )

};
export default OrderRefundForm
